import { createAction, props } from '@ngrx/store'

// login action
export const login = createAction('[Authentication] Login')
export const loginSuccess = createAction(
  '[Authentication] Login Success',
  props<{ user: any; token: string }>()
)
export const loginFailure = createAction(
  '[Authentication] Login Failure',
  props<{ error: any }>()
)

// refresh the stored user claims once the OIDC lib has fully processed them (post code-exchange). Separate
// from loginSuccess so it updates state.user WITHOUT re-triggering the login effects.
export const setUser = createAction(
  '[Authentication] Set User',
  props<{ user: any }>()
)

// permissions resolved server-side (GET /api/v1/me) and loaded post-login for UI gating
export const setPermissions = createAction(
  '[Authentication] Set Permissions',
  props<{ permissions: string[] }>()
)

// logout action
export const logout = createAction('[Authentication] Logout')

export const logoutSuccess = createAction('[Auth] Logout Success')
